import posthog from 'posthog-js';
import {
    INSTANCE_ID,
    VITE_PUBLIC_POSTHOG_HOST,
    VITE_PUBLIC_POSTHOG_TOKEN,
    WEBAPP_ROUTE_PREFIX,
} from '~/constants';

let circuitOpen = false;
let failureCount = 0;
const FAILURE_THRESHOLD = 3;
const CIRCUIT_RESET_MS = 5 * 60 * 1000; // 5 minutes

if (VITE_PUBLIC_POSTHOG_TOKEN) {
    posthog.init(VITE_PUBLIC_POSTHOG_TOKEN, {
        api_host: `${window.location.origin}${WEBAPP_ROUTE_PREFIX}/posthog-proxy`,
        ui_host: VITE_PUBLIC_POSTHOG_HOST,
        defaults: '2026-01-30',
        opt_out_capturing_by_default: true, // RGPD: User must explicitly opt-in
        before_send: (event) => {
            if (circuitOpen) return null;
            return event;
        },
        on_request_error: () => {
            failureCount += 1;
            if (failureCount >= FAILURE_THRESHOLD && !circuitOpen) {
                circuitOpen = true;
                setTimeout(() => {
                    circuitOpen = false;
                    failureCount = 0;
                }, CIRCUIT_RESET_MS);
            }
        },
    });
    posthog.register({ instance_id: INSTANCE_ID });
}

export default posthog;
